import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common Components
import { Button, DynamicMultiSelectDropdown, TextInput } from "src/Components";
// Services
import {
  createLiquidityManagementTask,
  editLiquidityManagementTask,
  getLiquidityUsers,
} from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import {
  ILiquidityManagementTableReport,
  ILiquidityManagementTask,
} from "src/Interfaces/imePortfolio";

interface IProps {
  row?: ILiquidityManagementTableReport;
  onSuccess?: () => void;
  onClose?: () => void;
}

const AddLiquidityModal: React.FC<IProps> = ({ row, onSuccess, onClose }) => {
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] = React.useState<ILiquidityManagementTask>(
    () => ({
      userIds:
        (row as any)?.userIds ||
        ((row as any)?.userId ? [(row as any).userId] : []),
      withdrawThreshold: (row as any)?.withdrawThreshold,
      equilibriumLevel: (row as any)?.equilibriumLevel,
      autoWithdraw: (row as any)?.autoWithdraw ?? true,
    }),
  );

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const submitHandler = () => {
    setLoading(true);
    const request = row
      ? editLiquidityManagementTask({
          ...formValues,
          id: row.id,
        } as ILiquidityManagementTask)
      : createLiquidityManagementTask(formValues);

    request
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          if (onSuccess) onSuccess();
          if (onClose) onClose();
        } else {
          toast.error(resp.msg);
          if (onClose) onClose();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const isDisabled =
    loading ||
    !formValues.userIds?.length ||
    (!formValues.withdrawThreshold && formValues.withdrawThreshold !== 0) ||
    (!formValues.equilibriumLevel && formValues.equilibriumLevel !== 0);

  return (
    <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "userIds",
          placeholder: "اکانت",
          extraLabel: true,
        }}
        getData={getLiquidityUsers}
        onChange={changeHandler}
        value={formValues.userIds || []}
        withTagBox
      />
      <TextInput
        label="درصد آستانه برداشت"
        name="withdrawThreshold"
        value={formValues.withdrawThreshold?.toString() || ""}
        onChange={changeHandler}
        kind="percent"
        extraLabel
      />
      <TextInput
        label="درصد سطح تعادلی"
        name="equilibriumLevel"
        value={formValues.equilibriumLevel?.toString() || ""}
        onChange={changeHandler}
        kind="percent"
        extraLabel
      />
      <div className="w-20 self-center">
        <Button
          text={row ? "ویرایش" : "افزودن"}
          onClick={submitHandler}
          variant="contained"
          loading={loading}
          disabled={isDisabled}
        />
      </div>
    </div>
  );
};

export default AddLiquidityModal;
